import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Login = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await login(formData.username, formData.password);

    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <div className="auth-container login-modern-shell">
      <div className="login-modern-backdrop-shape login-modern-backdrop-shape--one"></div>
      <div className="login-modern-backdrop-shape login-modern-backdrop-shape--two"></div>

      <div className="auth-wrapper login-modern-wrapper">
        <div className="auth-card login-modern-card">
          <div className="login-modern-badge">
            <img src="/logo192.png" alt="VH logo" className="login-modern-badge__logo" />
            <span className="login-modern-badge__text">VrisHr</span>
          </div>

          <div className="auth-header text-center mb-4 login-modern-header">
            <div className="auth-icon login-modern-icon">
              <i className="bi bi-shield-lock"></i>
            </div>
            <h2 className="auth-title">Welcome Back</h2>
            <p className="auth-subtitle mb-0">Secure sign in to your HR workspace</p>
          </div>

          {error && (
            <div className="alert alert-danger d-flex align-items-center login-modern-alert" role="alert">
              <i className="bi bi-exclamation-triangle-fill me-2"></i>
              <div>{error}</div>
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group mb-3">
              <label className="form-label login-modern-label">
                <i className="bi bi-person me-2"></i>Username
              </label>
              <div className="input-group login-modern-input-wrap">
                <span className="input-group-text login-modern-input-icon">
                  <i className="bi bi-at"></i>
                </span>
                <input
                  type="text"
                  name="username"
                  className="form-control form-control-lg login-modern-input"
                  placeholder="Enter your username"
                  value={formData.username}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form-group mb-4">
              <label className="form-label login-modern-label">
                <i className="bi bi-lock me-2"></i>Password
              </label>
              <div className="input-group login-modern-input-wrap">
                <span className="input-group-text login-modern-input-icon">
                  <i className="bi bi-key"></i>
                </span>
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  className="form-control form-control-lg login-modern-input"
                  placeholder="Enter your password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
                <button
                  type="button"
                  className="btn btn-outline-secondary login-modern-toggle"
                  onClick={() => setShowPassword((prev) => !prev)}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                  <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-lg w-100 mb-3 auth-btn login-modern-submit"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                  Signing In...
                </>
              ) : (
                <>
                  <i className="bi bi-box-arrow-in-right me-2"></i>
                  Sign In
                </>
              )}
            </button>
          </form>

          <div className="auth-footer text-center login-modern-footer">
            <div className="login-modern-trust">
              <span><i className="bi bi-shield-check me-1"></i>Encrypted Session</span>
              <span><i className="bi bi-clock-history me-1"></i>Fast Access</span>
            </div>
            <p className="mb-0">
              Don't have an account?{' '}
              <Link to="/register" className="auth-link">
                Sign up here
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
